function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4EA15A",
  fillRule: "nonzero",
  d: "M17.664 8.235a2.5 2.5 0 010 3.536l-5.893 5.893a2.5 2.5 0 01-3.536 0L2.342 11.77a2.5 2.5 0 010-3.536l5.893-5.893a2.5 2.5 0 013.536 0l5.893 5.893z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4EA15A",
  fillRule: "nonzero",
  d: "M15.94 9.458l-5.402-5.401a.764.764 0 00-1.014-.06l-.066.06-5.402 5.401a.764.764 0 00-.06 1.014l.06.067 5.402 5.402a.764.764 0 001.014.059l.067-.06 5.4-5.4A.764.764 0 0016 9.526l-.06-.068z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 2.708,
  fill: "#4EA15A",
  fillRule: "nonzero"
}));

function SvgGivenFeedbackQuestionBadgeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _ref);
}

export default SvgGivenFeedbackQuestionBadgeIcon;